// app/javascript/controllers/application.js

import { Application } from "@hotwired/stimulus"

const application = Application.start()

export { application }

console.log("Stimulus started")
